<h2>Ziply Welcome Call</h2>

<div>
    <form [formGroup]="welcomeCallForm">
        <nz-form-item>
            <nz-form-label [nzSpan]="6" nzFor="first_name" nzRequired>First Name</nz-form-label>
            <nz-form-control [nzSpan]="14">
                <input nz-input formControlName="first_name" type="text" id="first_name" placeholder="First Name" required/>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="6" nzFor="last_name" nzRequired>Last Name</nz-form-label>
            <nz-form-control [nzSpan]="14">
                <input nz-input formControlName="last_name" type="text" id="last_name" placeholder="Last Name" required/>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="6" nzFor="phone" nzRequired>Phone</nz-form-label>
            <nz-form-control [nzSpan]="14">
                <input nz-input formControlName="phone" type="tel" id="phone" mask="(000) 000-0000" placeholder="(123) 123-1234" required/>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="6" nzFor="email" nzRequired>Email</nz-form-label>
            <nz-form-control [nzSpan]="14">
                <input nz-input formControlName="email" type="email" id="email" placeholder="email@email.com"
                    required />
            </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="pinSent">
            <nz-form-label [nzSpan]="6" nzFor="pin" nzRequired>Enter PIN</nz-form-label>
            <nz-form-control [nzSpan]="14">
                <input nz-input formControlName="pin" type="text" id="pin" placeholder="PIN"/>
            </nz-form-control>
        </nz-form-item>
    </form>

    <div style="display: flex; justify-content: center; gap: 10px; margin-top: 8px;">
        <button *ngIf="!pinSent" [nzLoading]="loading" nz-button nzType="default" style="width: 160px;" (click)="resetForm()">Reset</button>
        <button [nzLoading]="loading" nz-button nzType="default" style="width: 160px;" (click)="sendPin()"> {{ countdown > 0 ? 'Resend in ' + countdown + 's' : 'Send PIN' }}</button>
        <button [nzLoading]="loading" nz-button nzType="primary" style="width: 160px;" (click)="confirmPin()" [disabled]="!pinSent || !welcomeCallForm.get('pin')?.value">Confirm</button>
    </div>
</div>